import React, { useState } from "react";
import { observer } from "mobx-react";
import classnames from "classnames/bind";

import CargoOwnersDropdown from "../../MainMenu/dropdowns/CargoOwnersDropdown";
import CarriersDropdown from "../../MainMenu/dropdowns/CarriersDropdown";
import DocsDropdown from "../../MainMenu/dropdowns/DocsDropdown";
import AnalyticsDropdown from "../../MainMenu/dropdowns/AnalyticsDropdown/AnalyticsDropdown";

import OnlineLoansButton from "../../OnlineLoansButton";
import CargoOwnerButton from "../../CargoOwnerButton";

import BurgerSection from "./BurgerSection";
import BurgerButton from "./BurgerButton";
import DropdownHeader from "./DropdownHeader";

import { sendNavigationMetric } from "../../../utils/sendMetric";

import { useStore } from "../../../connect";

import {
  popupWindowParams,
  MAIN_PAGE_QUERY_PARAM_STRING,
  MAIN_PAGE_QUERY_PARAM,
} from "../../../consts";

import strings from "../../../locales/strings";

import styles from "../Burger.scss";

const cx = classnames.bind(styles);

const BurgerDropdown = () => {
  const { chat, profile, baseUrl, locale, header, abTest } = useStore();
  const [page, setPage] = useState("main");

  const analyticsLabel = strings.mainMenu_analitics[abTest.analyticsHeaderVariant];
  const openLoginPopup = (next) => {
    profile.onLoginOpen({
      next,
      additionalQueryParams: header.isMainPage ? MAIN_PAGE_QUERY_PARAM : null,
    });
  };

  const openPopup = (event, popupName, href) => {
    event.preventDefault();
    window.open(href, popupName, popupWindowParams);
  };

  const goTo = (event, newPage) => {
    event.preventDefault();
    event.stopPropagation();

    setPage(newPage);
  };

  const goToMain = (event) => {
    goTo(event, "main");
  };

  const goToCargoOwners = (event) => {
    goTo(event, "cargoOwners");
  };

  const goToCarriers = (event) => {
    goTo(event, "carriers");
  };

  const goToDocs = (event) => {
    goTo(event, "docs");
  };

  const goToAnalitycs = (event) => {
    sendNavigationMetric(`MAIN_MENU_BUTTON_${abTest.analyticsHeaderVariant.toUpperCase()}`)
    goTo(event, "analitycs");
  };

  const handleAddLoadClick = (event) => {
    sendNavigationMetric("BURGER_ADD_CARGO");
    if (profile.isLoggedIn) {
      openPopup(
        event,
        "addLoad",
        `https://loads.${baseUrl}/cargos/create?utm_source=header&utm_campaign=new_header`
      );
      return;
    }

    openLoginPopup(
      `https://loads.${baseUrl}/published?utm_source=header&utm_campaign=new_header`
    );
  };

  const handleAddTruckClick = () => {
    if (!profile.isLoggedIn) {
      openLoginPopup(
        `https://trucks.${baseUrl}/published?utm_source=header&utm_campaign=new_header${
          header.isMainPage ? `&${MAIN_PAGE_QUERY_PARAM_STRING}` : ""
        }`
      );

      return;
    }

    window.location.href = `https://trucks.${baseUrl}/trucks/create?utm_source=header&utm_campaign=new_header${
      header.isMainPage ? `&${MAIN_PAGE_QUERY_PARAM_STRING}` : ""
    }`;
  };

  return (
    <div
      className={cx("burger-dropdown", {
        "not-main-page": page !== "main",
        "not-full-width": page === "analitycs" && analyticsLabel,
      })}
    >
      {page === "main" && (
        <>
          <BurgerSection>
            {/* Грузовладельцам */}
            <BurgerButton
              afterIconName="ic_arrow-right-out"
              counter={profile.counters.cargoOwners}
              onClick={goToCargoOwners}
            >
              {strings.cargoOwners}
            </BurgerButton>

            {/* Перевозчикам */}
            <BurgerButton
              afterIconName="ic_arrow-right-out"
              counter={profile.counters.carriers}
              onClick={goToCarriers}
            >
              {strings.carriers}
            </BurgerButton>

            {/* Ати-доки */}
            <BurgerButton
              afterIconName="ic_arrow-right-out"
              counter={profile.counters.docs}
              onClick={goToDocs}
            >
              {strings.mainMenu_atiDocs}
            </BurgerButton>

            {/* Аналитика */}
            {analyticsLabel && (<BurgerButton
              afterIconName="ic_arrow-right-out"
              onClick={goToAnalitycs}
            >
              {analyticsLabel}
            </BurgerButton>)}
          </BurgerSection>
          <BurgerSection>
            <BurgerButton
              beforeIconName="ic_message-solid"
              counter={chat.chatUnreadCount}
              onClick={chat.handleChatButtonClick}
            >
              {strings.atiMessenger}
            </BurgerButton>
          </BurgerSection>
          <BurgerSection>
            {/* Добавить груз */}
            <BurgerButton
              beforeIconName="ic_add-out"
              onClick={handleAddLoadClick}
            >
              {strings.burger_addLoad}
            </BurgerButton>

            {/* Добавить машину */}
            <BurgerButton
              beforeIconName="ic_add-out"
              newTab
              onClick={(event) => {
                sendNavigationMetric("BURGER_ADD_TRUCK");
                handleAddTruckClick(event);
              }}
            >
              {strings.burger_addTruck}
            </BurgerButton>
          </BurgerSection>
          {profile.isLoggedIn &&
            !!profile.user.loan_info &&
            !!profile.user.loan_info.loan_limit && (
              <BurgerSection>
                <OnlineLoansButton
                  className={cx("burger-loans-button")}
                  baseUrl={baseUrl}
                  loanLimit={profile.user.loan_info.loan_limit}
                  locale={locale}
                  role={profile.user.loan_info.loan_role}
                />
              </BurgerSection>
            )}
          {profile.isLoggedIn &&
            (profile.user.firm_type_id === 3 ||
              profile.user.firm_type_id === 6) &&
            profile.user.country_id === 1 && (
              <BurgerSection>
                <CargoOwnerButton
                  className={cx("burger-cargo-owner-button")}
                  baseUrl={baseUrl}
                  locale={locale}
                />
              </BurgerSection>
            )}
        </>
      )}
      {page === "cargoOwners" && (
        <>
          <DropdownHeader onClick={goToMain} label={strings.cargoOwners} />
          <CargoOwnersDropdown isMobile />
        </>
      )}
      {page === "carriers" && (
        <>
          <DropdownHeader onClick={goToMain} label={strings.carriers} />
          <CarriersDropdown isMobile />
        </>
      )}
      {page === "docs" && (
        <>
          <DropdownHeader onClick={goToMain} label={strings.mainMenu_atiDocs} />
          <DocsDropdown isMobile />
        </>
      )}
      {page === "analitycs" && analyticsLabel && (
        <>
          <DropdownHeader onClick={goToMain} label={analyticsLabel} />
          <AnalyticsDropdown isMobile />
        </>
      )}
    </div>
  );
};

export default observer(BurgerDropdown);
